var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03129 1.88855L5.01106 10.463L1.22161 14.2525C0.592797 14.8813 0.592797 15.9008 1.22161 16.5296L2.3602 17.6682C2.98901 18.297 4.00853 18.297 4.63734 17.6682L8.4268 13.8788L17.0013 9.85853M18.1398 10.997L7.89274 0.75M16.501 4.80404L18.1398 3.97034M14.0858 2.38879L14.9195 0.75",
    stroke: "#707070",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15055 16.1574L9.25649 19.2634C9.5491 19.5646 9.95848 19.7518 10.4117 19.7518C11.301 19.7518 12.0218 19.0309 12.0218 18.1416C12.0218 17.6885 11.8346 17.2791 11.5334 16.9865L5.01172 10.4648",
    stroke: "#707070",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingLogo);
export default __webpack_public_path__ + "static/media/MarketingLogo.7207bc3021f30c7b982a8795c8cf4a3d.svg";
export { ForwardRef as ReactComponent };